<template lang="pug">
  div.card
    slot
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .card {
    box-shadow: none;
    background-color: white;
  }
</style>
